import { useTranslations } from "next-intl";
import type { ReactElement } from "react";

/** Stack aside: under the embed on desktop, after bullets on mobile. */
export function DevelopersStackLogos({
  className,
}: {
  readonly className?: string;
}): ReactElement {
  const t = useTranslations("public.developersStackLogos");
  const noteClassName: string =
    className === undefined ? "dvf-logos-note" : `dvf-logos-note ${className}`;
  return <p className={noteClassName}>{t("weDonAposT")}</p>;
}
